__turbopack_context__.v({
  "aiActions": "RichAIField-module__VkSE1W__aiActions",
  "container": "RichAIField-module__VkSE1W__container",
  "divider": "RichAIField-module__VkSE1W__divider",
  "error": "RichAIField-module__VkSE1W__error",
  "errorBannerWrapper": "RichAIField-module__VkSE1W__errorBannerWrapper",
  "errorIcon": "RichAIField-module__VkSE1W__errorIcon",
  "errorText": "RichAIField-module__VkSE1W__errorText",
  "fieldWrapper": "RichAIField-module__VkSE1W__fieldWrapper",
  "focused": "RichAIField-module__VkSE1W__focused",
  "formatButton": "RichAIField-module__VkSE1W__formatButton",
  "formatButtonActive": "RichAIField-module__VkSE1W__formatButtonActive",
  "inlinePlaceholderMenu": "RichAIField-module__VkSE1W__inlinePlaceholderMenu",
  "interactive": "RichAIField-module__VkSE1W__interactive",
  "placeholderMenuItem": "RichAIField-module__VkSE1W__placeholderMenuItem",
  "placeholderMenuItemActive": "RichAIField-module__VkSE1W__placeholderMenuItemActive",
  "placeholderMenuToken": "RichAIField-module__VkSE1W__placeholderMenuToken",
  "placeholderToken": "RichAIField-module__VkSE1W__placeholderToken",
  "skeletonLine": "RichAIField-module__VkSE1W__skeletonLine",
  "skeletonOverlay": "RichAIField-module__VkSE1W__skeletonOverlay",
  "skeletonShimmer": "RichAIField-module__VkSE1W__skeletonShimmer",
  "toolbar": "RichAIField-module__VkSE1W__toolbar",
});
